<template>
  <div class="sendManage column-me">
    <div class="tab-div row-me">
      <div class="tab-item column-me row-center" @click="clickTab(0)">
        <div class="tab-title" :class="{'tab-title-active':tabIndex===0}">待发货列表</div>
        <div class="tab-line" :class="{'tab-line-active':tabIndex===0}"></div>
      </div>
      <div class="tab-item column-me row-center" @click="clickTab(2)">
        <div class="tab-title" :class="{'tab-title-active':tabIndex===2}">发货联单</div>
        <div class="tab-line" :class="{'tab-line-active':tabIndex===2}"></div>
      </div>
      <div class="tab-item column-me row-center" @click="clickTab(1)">
        <div class="tab-title" :class="{'tab-title-active':tabIndex===1}">发货查询</div>
        <div class="tab-line" :class="{'tab-line-active':tabIndex===1}"></div>
      </div>
    </div>

    <div class="card-div column-me flex1" v-show="tabIndex===0 || tabIndex===1">
      <div class="row-me row-center flex-wrap">
        <div class="width180">
          <el-input placeholder="处方订单号" style="width: 100%;" clearable v-model="number"></el-input>
        </div>
        <div class="width150 margin-left10">
          <el-input placeholder="患者姓名" style="width: 100%;" clearable v-model="name"></el-input>
        </div>
        <div class="width150 margin-left10">
          <el-select placeholder="医院名称" style="width: 100%;" filterable clearable v-model="hospital">
            <el-option v-for="item in hospitalArray" :key="item.id" :label="item.name" :value="item.name">
            </el-option>
          </el-select>
        </div>
        <div class="width120 margin-left10">
          <el-input placeholder="机构名称" style="width: 100%;" clearable v-model="organization"></el-input>
        </div>
        <div class="width130 margin-left10" v-if="tabIndex===1">
          <el-select placeholder="日期类型" style="width: 100%;" filterable clearable v-model="selectDateType">
            <el-option v-for="item in [{id:0,name:'传方日期'},{id:1,name:'发货日期'},{id:3,name:'包装完成日期'}]"
                       :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </div>
        <div class="width300 margin-left10">
          <el-date-picker type="daterange" range-separator="-" start-placeholder="开始日期"
                          end-placeholder="结束日期" value-format="YYYY-MM-DD" clearable v-model="selectDate">
          </el-date-picker>
        </div>
        <div class="width130 margin-left10">
          <el-select placeholder="配送方式" style="width: 100%;" filterable clearable v-model="selectCompany">
            <el-option v-for="item in companyArray" :key="item.id" :label="item.name" :value="item.name">
            </el-option>
          </el-select>
        </div>
        <div class="width130 margin-left10">
          <el-select placeholder="面单打印" style="width: 100%;" filterable clearable v-model="selectPrintStatus">
            <el-option v-for="item in printStatusArray" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </div>
        <div class="btn-blue width100 btn-height40 margin-left10" @click="clickSearch">
          <el-icon>
            <search/>
          </el-icon>
          搜索
        </div>
        <div class="btn-blank width100 btn-height40 margin-left10" @click="clickClear">清空</div>
      </div>
      <div class="row-me row-center margin-top20">
        <div class="btn-green width120 btn-height40 margin-right10" @click="clickSend" v-if="canOperate&&tabIndex===0">
          发货
        </div>
        <div class="btn-green width120 btn-height40 margin-right10" @click="clickCancelSend"
             v-if="canOperate&&tabIndex===1">
          取消发货
        </div>
        <div class="btn-green width120 btn-height40 margin-right10" @click="clickReceive"
             v-if="canOperate&&tabIndex===1">
          签收
        </div>
        <div class="btn-blue width120 btn-height40 margin-right10" @click="clickMergeOrder"
             v-if="canOperate&&tabIndex===0">
          生成联单
        </div>
        <div class="btn-blank width120 btn-height40 margin-right10" @click="clickPrintFaceOrder">
          打印面单
        </div>
        <div class="btn-blank width120 btn-height40 margin-right10" @click="clickAddRemark" v-if="canOperate">
          添加备注
        </div>
        <div class="btn-blank width100 btn-height40 margin-right10" @click="clickExport">导出</div>
        <div class="btn-blank width100 btn-height40 margin-right10" @click="clickExpressInfo" v-if="tabIndex===1">
          物流信息
        </div>
      </div>
      <div class="column-me flex1 margin-top20 overflow-auto">
        <div class="flex1 overflow-auto">
          <el-table :data="tableData" border header-cell-class-name="table-header-style"
                    cell-class-name="table-cell-style" @selection-change="selectionChange"
                    @row-click='rowClick' :row-class-name="tableRowClassName" height="100%">
            <el-table-column type="selection" align="center" width="50"></el-table-column>
            <el-table-column prop="orderNo" label="处方订单号" align="center" width="250"
                             show-overflow-tooltip></el-table-column>
            <el-table-column prop="hospitalName" label="医院名称" align="center" width="130"
                             show-overflow-tooltip></el-table-column>
            <el-table-column prop="mechName" label="机构名称" align="center" width="130"
                             show-overflow-tooltip></el-table-column>
            <el-table-column prop="prescriptionNumber" label="医院单号" align="center" width="200"
                             show-overflow-tooltip></el-table-column>
            <el-table-column prop="patientName" label="患者姓名" align="center" width="100"
                             show-overflow-tooltip></el-table-column>
            <el-table-column label="处方类型" align="center" width="100" show-overflow-tooltip>
              <template v-slot="scope">
                {{ scope.row.type === 0 ? '中药处方' : scope.row.type === 1 ? '中医外治' : '' }}
              </template>
            </el-table-column>
            <el-table-column prop="processType" label="加工类型" align="center" width="130"
                             show-overflow-tooltip></el-table-column>
            <el-table-column prop="isDecoction" label="是否代煎" align="center" width="100">
              <template #default='scope'>
                <div v-if="scope.row.val === 't' || scope.row.val === 'd' || scope.row.val === 'z'">
                  {{ scope.row.isDecoction ? '代煎' : '自煎' }}
                </div>
                <div v-else>代煎</div>
              </template>
            </el-table-column>
            <el-table-column prop="packageNums" label="包装量" align="center" width="130"
                             show-overflow-tooltip></el-table-column>
            <el-table-column prop="doseNums" label="剂数" align="center" width="80"
                             show-overflow-tooltip></el-table-column>
            <el-table-column prop="frequency" label="次数" align="center" width="120"
                             show-overflow-tooltip></el-table-column>
            <el-table-column prop="mergeOrderNo" label="合单工单号" align="center" width="200"
                             show-overflow-tooltip></el-table-column>
            <el-table-column label="配送方式" align="center" width="150"
                             show-overflow-tooltip>
              <template #default='scope'>
                <div class="row-me center-all" v-if="scope.row.faStatus===0||scope.row.faStatus===null">
                  <div>{{ scope.row.deliveryCompany }}</div>
                  <div v-if="scope.row.deliveryType===0">(寄付)</div>
                  <div v-if="scope.row.deliveryType===1">(到付)</div>
                  <div v-if="scope.row.deliveryType===2">(月结)</div>
                </div>
                <div class="row-me center-all" v-else>
                  <div>{{ scope.row.sfDeliveryCompany }}</div>
                  <div v-if="scope.row.sfDeliveryType===0">(寄付)</div>
                  <div v-if="scope.row.sfDeliveryType===1">(到付)</div>
                  <div v-if="scope.row.sfDeliveryType===2">(月结)</div>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="面单打印" align="center" width="120"
                             show-overflow-tooltip>
              <template #default="scope">
                <div v-if="scope.row.printStatus===null">待打印</div>
                <div v-else>
                  {{
                    this.printStatusArray.filter(item => {
                      return item.id === scope.row.printStatus
                    }).map(item => {
                      return item.name
                    }).join('')
                  }}
                </div>
              </template>
            </el-table-column>
            <el-table-column label="处方状态" align="center" width="120" show-overflow-tooltip>
              <template #default='scope'>
                <div v-if="scope.row.faStatus===0||scope.row.faStatus===null">待发货</div>
                <div v-if="scope.row.faStatus===1">已发货</div>
                <div v-if="scope.row.faStatus===2">已签收</div>
              </template>
            </el-table-column>
            <el-table-column prop="faRemark" label="发货备注" align="center" width="150"
                             show-overflow-tooltip></el-table-column>
            <el-table-column label="收件人" align="center" width="120" show-overflow-tooltip>
              <template #default='scope'>
                <div v-if="scope.row.faStatus===0||scope.row.faStatus===null">
                  {{ scope.row.receiveName }}
                </div>
                <div v-else>
                  {{ scope.row.sfName }}
                </div>
              </template>
            </el-table-column>
            <el-table-column label="收件人地址" align="center" width="180" show-overflow-tooltip>
              <template #default='scope'>
                <div v-if="scope.row.faStatus===0||scope.row.faStatus===null">
                  {{ scope.row.receiveProvince }}{{ scope.row.receiveCity }}
                  {{ scope.row.receiveRegion }}{{ scope.row.receiveAddress }}
                </div>
                <div v-else>
                  {{ scope.row.sfProvince }}{{ scope.row.sfCity }}
                  {{ scope.row.sfRegion }}{{ scope.row.sfAddress }}
                </div>
              </template>
            </el-table-column>
            <el-table-column label="收件电话" align="center" width="150" show-overflow-tooltip>
              <template #default='scope'>
                <div v-if="scope.row.faStatus===0||scope.row.faStatus===null">
                  {{ scope.row.receiveMobile }}
                </div>
                <div v-else>
                  {{ scope.row.sfMobile }}
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="remark" label="传方备注" align="center" width="150"
                             show-overflow-tooltip></el-table-column>
            <el-table-column prop="createTime" label="传方时间" align="center" width="220"
                             show-overflow-tooltip></el-table-column>
            <el-table-column prop="deliveryNo" label="快递单号" align="center" width="200"
                             show-overflow-tooltip v-if="tabIndex===1"></el-table-column>
            <el-table-column label="运费" align="center" width="180" show-overflow-tooltip v-if="tabIndex===1">
              <template v-slot="scope">
                <div class="row-me center-all" v-if="!canOperate">
                  {{ scope.row.freightFee }}
                </div>
                <div v-else>
                  <div class="row-me center-all" v-if="scope.row.showEditPrice">
                    <div class="width80">
                      <el-input style="width: 100%;" v-model="scope.row.freightFee"
                                @input="()=>{scope.row.freightFee = $method.checkInput(scope.row.freightFee,2)}">
                      </el-input>
                    </div>
                    <img src="../../assets/img/ok.png" class="img-table pointer"
                         @click="clickPriceOk(scope.row)">
                    <img src="../../assets/img/cancel.png" class="img-table pointer"
                         @click="clickPriceCancel(scope.row)">
                  </div>
                  <div class="row-me center-all pointer" v-else @click="clickShowEdit(scope.row)">
                    <div class="flex1 align-right margin-right10">{{ scope.row.freightFee }}</div>
                    <img src="../../assets/img/edit.png" class="img-table pointer margin-right20">
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="sfSendType" label="寄件类型" align="center" width="120"
                             show-overflow-tooltip v-if="tabIndex===1"></el-table-column>
          </el-table>
        </div>
        <div class="margin-top20">
          <el-pagination background @current-change="handleCurrentChange" :current-page.sync="pageNo"
                         layout="total, prev, pager, next" :total="total">
          </el-pagination>
        </div>
      </div>
    </div>

    <!--发货联单-->
    <div class="card-div column-me flex1" v-show="tabIndex===2">
      <div class="row-me row-center flex-wrap">
        <div class="width180">
          <el-input placeholder="联单号" style="width: 100%;" clearable v-model="tab2Obj.linkOrderNo"></el-input>
        </div>
        <div class="width150 margin-left10">
          <el-select placeholder="医院名称" style="width: 100%;" filterable clearable v-model="tab2Obj.hospital">
            <el-option v-for="item in hospitalArray" :key="item.id" :label="item.name" :value="item.name">
            </el-option>
          </el-select>
        </div>
        <div class="width130 margin-left10">
          <el-select placeholder="联单状态" style="width: 100%;" filterable clearable v-model="tab2Obj.linkStatus">
            <el-option v-for="item in linkOrderStatusArray" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </div>
        <div class="width130 margin-left10">
          <el-select placeholder="打印状态" style="width: 100%;" filterable clearable v-model="tab2Obj.printStatus">
            <el-option v-for="item in printStatusArray" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </div>
        <div class="width300 margin-left10">
          <el-date-picker type="daterange" range-separator="-" start-placeholder="开始日期"
                          end-placeholder="结束日期" value-format="YYYY-MM-DD" clearable v-model="tab2Obj.selectDate">
          </el-date-picker>
        </div>
        <div class="btn-blue width100 btn-height40 margin-left10" @click="clickSearch">
          <el-icon>
            <search/>
          </el-icon>
          搜索
        </div>
        <div class="btn-blank width100 btn-height40 margin-left10" @click="clickClear">清空</div>
      </div>
      <div class="row-me row-center margin-top20">
        <div class="btn-green width120 btn-height40 margin-right10" @click="clickSend" v-if="canOperate">
          发货
        </div>
        <div class="btn-green width120 btn-height40 margin-right10" @click="clickCancelSend" v-if="canOperate">
          取消发货
        </div>
        <div class="btn-green width120 btn-height40 margin-right10" @click="clickReceive" v-if="canOperate">
          签收
        </div>
        <div class="btn-blank width120 btn-height40 margin-right10" @click="clickPrintFaceOrder">
          打印面单
        </div>
        <div class="btn-blank width100 btn-height40 margin-right10" @click="clickExportLink">导出</div>
        <div class="btn-blank width100 btn-height40 margin-right10" @click="clickCancel">作废</div>
        <div class="btn-blank width100 btn-height40 margin-right10" @click="clickDelete">删除</div>
      </div>
      <div class="margin-top20 flex1">
        <el-table :data="tab2Obj.tableData" border header-cell-class-name="table-header-style"
                  cell-class-name="table-cell-style" @selection-change="selectionChange" @row-click='rowClickLink'
                  :row-class-name="tableRowClassName" height="100%">
          <el-table-column type="selection" width="50" align="center"/>
          <el-table-column prop="jointNo" label="联单号" align="center" width="230"
                           show-overflow-tooltip></el-table-column>
          <el-table-column prop="hospitalName" label="医院名称" align="center" width="130"
                           show-overflow-tooltip></el-table-column>
          <el-table-column prop="mechName" label="机构名称" align="center" width="130"
                           show-overflow-tooltip></el-table-column>
          <el-table-column prop="prescriptionNums" label="处方数" align="center" width="130"
                           show-overflow-tooltip></el-table-column>
          <el-table-column prop="orderStatus" label="联单状态" align="center" width="120"
                           show-overflow-tooltip>
            <template #default="scope">
              {{
                this.linkOrderStatusArray.filter(item => {
                  return item.id === scope.row.orderStatus
                }).map(item => {
                  return item.name
                }).join('')
              }}
            </template>
          </el-table-column>
          <el-table-column prop="printStatus" label="打印状态" align="center" width="120"
                           show-overflow-tooltip>
            <template #default="scope">
              <div v-if="scope.row.printStatus===null">待打印</div>
              <div v-else>
                {{
                  this.printStatusArray.filter(item => {
                    return item.id === scope.row.printStatus
                  }).map(item => {
                    return item.name
                  }).join('')
                }}
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="operator" label="制单人" align="center" width="120"
                           show-overflow-tooltip></el-table-column>
          <el-table-column prop="createTime" label="制单时间" align="center" width="230"
                           show-overflow-tooltip></el-table-column>
          <el-table-column label="配送方式" align="center" width="130"
                           show-overflow-tooltip>
            <template #default='scope'>
              <div class="row-me center-all">
                <div>{{ scope.row.deliveryCompany }}</div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="deliveryNo" label="快递单号" align="center" width="200"
                           show-overflow-tooltip></el-table-column>
          <el-table-column label="运费" align="center" width="180" show-overflow-tooltip>
            <template v-slot="scope">
              <div class="row-me center-all" v-if="!canOperate">
                {{ scope.row.freightFee }}
              </div>
              <div v-else>
                <div class="row-me center-all" v-if="scope.row.showEditPrice">
                  <div class="width80">
                    <el-input style="width: 100%;" v-model="scope.row.freightFee"
                              @input="()=>{scope.row.freightFee = $method.checkInput(scope.row.freightFee,2)}">
                    </el-input>
                  </div>
                  <img src="../../assets/img/ok.png" class="img-table pointer"
                       @click="clickPriceOk(scope.row)">
                  <img src="../../assets/img/cancel.png" class="img-table pointer"
                       @click="clickPriceCancel(scope.row)">
                </div>
                <div class="row-me center-all pointer" v-else @click="clickShowEdit(scope.row)">
                  <div class="flex1 align-right margin-right10">{{ scope.row.freightFee }}</div>
                  <img src="../../assets/img/edit.png" class="img-table pointer margin-right20">
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="sendType" label="寄件类型" align="center" width="120"
                           show-overflow-tooltip></el-table-column>
          <el-table-column prop="remark" label="备注" align="center" width="150"
                           show-overflow-tooltip></el-table-column>
        </el-table>
      </div>
      <div class="margin-top10">
        <el-pagination @current-change="handleCurrentChange2" :current-page.sync="tab2Obj.pageNo"
                       layout="total, prev, pager, next, jumper" :total="tab2Obj.total">
        </el-pagination>
      </div>
    </div>

    <!-- 详情 -->
    <el-dialog v-model="visibleDetail" width="95%" :destroy-on-close="true" top="3vh"
               custom-class="detail-fang" @close="getData">
      <template #title>
        <div class="row-me row-center">
          <div class="dialog-title">{{ selectItem.orderNo }}&emsp;{{ selectItem.patientName }}</div>
          <div class="btn-next row-me center-all" @click="clickLeft">
            <el-icon color="#FFFFFF" style="margin-right: 0;">
              <arrowleft/>
            </el-icon>
            <span>上一个</span>
          </div>
          <div class="btn-next row-me center-all" @click="clickRight">
            <span>下一个</span>
            <el-icon color="#FFFFFF" style="margin-right: 0;">
              <arrowright/>
            </el-icon>
          </div>
        </div>
      </template>
      <fangDetail :id="selectItem.id"></fangDetail>
    </el-dialog>

    <!-- 添加备注 -->
    <el-dialog title="添加备注" v-model="visibleRemark" width="820px" top="20vh" :destroy-on-close="true">
      <div class="padding10-20">
        <div class="flex1">
          <el-input type="textarea" placeholder="请输入备注" style="width: 100%;" clearable v-model="remark"
                    maxlength="500" show-word-limit rows="10"></el-input>
        </div>
        <div class="row-me row-center flex-end1 margin-top40">
          <div class="btn-blank width100 btn-height40" @click="visibleRemark=false">取消</div>
          <div class="btn-blue width100 btn-height40 margin-left10" @click="clickSaveRemark">保存</div>
        </div>
      </div>
    </el-dialog>

    <!-- 生成联单 -->
    <el-dialog title="生成联单" v-model="visibleLinkOrder" width="820px" top="20vh" :destroy-on-close="true">
      <div class="padding-left50 padding-right50">
        <div>
          共选择{{ ids.length }}条处方订单需要联单发货，请先选择配送方式及收货地址，若配送方式为顺丰速运还需要确定母单
        </div>
        <div class="row-me row-center margin-top20">
          <div class="left-div">配送方式：</div>
          <div class="flex1 margin-left10">
            <el-select placeholder="请选择配送方式" style="width: 100%;" filterable clearable
                       v-model="linkOrderItem.deliveryCompany" @change="deliveryCompanyChange">
              <el-option v-for="item in companyArray" :key="item.id" :label="item.name" :value="item.name">
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="row-me row-center margin-top20" v-if="showParentOrder">
          <div class="left-div">选择母单：</div>
          <div class="flex1 margin-left10">
            <el-select placeholder="请选择母单" style="width: 100%;" filterable clearable
                       v-model="linkOrderItem.orderId" @change="parentOrderIdChange">
              <el-option v-for="item in checkedItemArray" :key="item.id" :label="item.orderNo+'-'+item.patientName"
                         :value="item.id">
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="row-me row-center margin-top20">
          <div class="left-div">收件人信息：</div>
          <div class="flex1 margin-left10">
            <el-input placeholder="请输入收件人姓名" style="width: 100%;" clearable
                      v-model="linkOrderItem.receiveName"></el-input>
          </div>
          <div class="flex1 margin-left10">
            <el-input placeholder="请输入收件人电话" style="width: 100%;" clearable
                      @input="linkOrderItem.receiveMobile=this.$method.checkInput(linkOrderItem.receiveMobile,0)"
                      v-model="linkOrderItem.receiveMobile"></el-input>
          </div>
        </div>
        <div class="row-me margin-top20">
          <div class="left-div">收货地址：</div>
          <div class="column-me flex1 margin-left10">
            <div class="row-me row-center">
              <div class="flex1">
                <el-select v-model="linkOrderItem.receiveProvince" placeholder="请选择省" style="width: 100%;"
                           filterable
                           clearable @change="provinceChange">
                  <el-option v-for="item in provinceArray" :key="item.id" :label="item.n"
                             :value="item.n">
                  </el-option>
                </el-select>
              </div>
              <div class="flex1 margin-left10">
                <el-select v-model="linkOrderItem.receiveCity" placeholder="请选择市" style="width: 100%;" filterable
                           clearable @change="cityChange">
                  <el-option v-for="item in cityArray" :key="item.id" :label="item.n" :value="item.n">
                  </el-option>
                </el-select>
              </div>
              <div class="flex1 margin-left10">
                <el-select v-model="linkOrderItem.receiveRegion" placeholder="请选择区/县" style="width: 100%;"
                           filterable
                           clearable>
                  <el-option v-for="item in areaArray" :key="item.id" :label="item.n" :value="item.n">
                  </el-option>
                </el-select>
              </div>
            </div>
            <div class="flex1 margin-top20">
              <el-input placeholder="请输入详细地址" style="width: 100%;" clearable
                        v-model="linkOrderItem.receiveAddress" maxlength="50"></el-input>
            </div>
          </div>
        </div>

        <div class="row-me row-center flex-end1 margin-top40">
          <div class="btn-blank width100 btn-height40" @click="visibleLinkOrder=false">取消</div>
          <div class="btn-blue width100 btn-height40 margin-left10" @click="clickSaveLinkOrder">确定</div>
        </div>
      </div>
    </el-dialog>

    <!-- 发货弹窗 -->
    <el-dialog title="发货" v-model="visibleSend" width="60%" top="5vh" :destroy-on-close="true">
      <send-dialog :orderArray="sendItemArray" :source="tabIndex===2?'link':'normal'"
                   @sendSuccess="sendSuccess"></send-dialog>
    </el-dialog>

    <!-- 联单详情 -->
    <el-dialog title="修改配送联单" v-model="visibleLinkDetail" width="70%" top="5vh" :destroy-on-close="true"
               @close="getLinkOrderData">
      <link-order-detail :id="selectItem.id"></link-order-detail>
    </el-dialog>

    <!-- 物流信息 -->
    <el-dialog title="物流信息" v-model="visibleExpressInfo" width="50%" top="5vh" :destroy-on-close="true">
      <div class="padding-left50">
        <div class="margin-bottom30" v-for="(item,index) in logsInfoArray" :key="index">
          <div class="margin-bottom20 font-bold">患者{{ item.name }}的单号【{{ item.orderNo }}】物流信息</div>
          <el-timeline>
            <el-timeline-item :timestamp="item1.remark" placement="top" v-for="(item1,index1) in item.list"
                              :key="index1">
              <div class="row-me margin-top20">
                <div class="logistics-title">{{ item1.acceptTime }}</div>
                <div class="grey-div margin-left15">
                  {{ item1.acceptAddress }}
                </div>
              </div>
            </el-timeline-item>
          </el-timeline>
        </div>
      </div>
    </el-dialog>

    <!-- 打印面单 -->
    <el-dialog title="打印面单" v-model="visibleFaceOrder" width="80%" top="5vh" :destroy-on-close="true">
      <print-face-order :orderArray="checkedItemArray" :source="tabIndex===2?'link':'normal'">
      </print-face-order>
    </el-dialog>

  </div>
</template>

<script>
import fangDetail from './fangDetail.vue'
import importExcel from '../../components/import/importExcel.vue'
import cityData from '../../assets/js/citys.js'
import sendDialog from './sendDialog.vue'
import linkOrderDetail from './linkOrderDetail.vue'
import printFaceOrder from "./printFaceOrder.vue";

export default {
  components: {
    fangDetail,
    importExcel,
    sendDialog,
    linkOrderDetail,
    printFaceOrder
  },
  data() {
    return {
      tabIndex: 0,//0待发货，1发货查询，2发货联单
      number: '',
      name: '',
      hospital: '',
      organization: '',
      hospitalArray: [],
      selectDateType: 0,
      selectDate: [],
      selectCompany: '',//配送方式
      selectPrintStatus: '',//面单是否打印
      visibleRemark: false,
      remark: '',
      tableData: [],
      pageNo: 1,
      total: 0,
      visibleDetail: false,
      selectItem: {}, //选择的处方
      ids: [], //选择框选择的id
      checkedItemArray: [], //选择框选择的订单
      canOperate: false,
      visibleLinkOrder: false,
      linkOrderItem: {//生成联单对象
        deliveryCompany: '',
        orderId: '',
        orderIds: [],//订单ID集合
        receiveName: '',
        receiveMobile: '',
        receiveProvince: '',
        receiveCity: '',
        receiveRegion: '',
        receiveAddress: '',
      },
      provinceArray: [],
      cityArray: [],
      areaArray: [],
      visibleSend: false,
      tab2Obj: {
        linkOrderNo: '',
        hospital: '',
        linkStatus: '',
        printStatus: '',
        selectDate: [],
        pageNo: 1,
        total: 0,
        tableData: [],
      },
      visibleLinkDetail: false,
      visibleExpressInfo: false,
      visibleFaceOrder: false,
      linkOrderStatusArray: [
        {id: 0, name: '已作废'},
        {id: 1, name: '已制单'},
        {id: 2, name: '已签收'},
        {id: 4, name: '已发货'}
      ],
      printStatusArray: [
        {id: 1, name: '待打印'},
        {id: 2, name: '已打印'},
      ],
      companyArray: [],//快递公司下拉
      isSaving: false,//是否保存中
      logsInfoArray: [],//物流信息集合
      sendItemArray: [],//可发货的订单
      showParentOrder: false,//是否显示母单
      isOpenSF: false,//是否开通顺丰
    }
  },
  // html加载完成之前
  created() {
    this.$getMenuOperateAuth(this.$route.path).then(res => {
      this.canOperate = res.data
    })
    this.getIsOpenSF()
    this.getHospitalArray()
    this.getDelivery()
    this.pageNo = 1
    this.getData()
    this.provinceArray = cityData
  },
  // html加载完成后执行。
  mounted() {

  },
  // 事件方法执行
  methods: {
    //显示编辑
    clickShowEdit(item) {
      item.freightFee1 = item.freightFee
      item.showEditPrice = true
    },
    //修改价格
    clickPriceOk(item) {
      this.$postFormRequest('/admin/order/updateFreightFee', {
        id: item.id,
        price: Number(item.freightFee),
        type: this.tabIndex === 2 ? 1 : 2,//type=1联单，2订单
      }).then((res) => {
        if (res) {
          this.$message.success(res.message)
          item.showEditPrice = false
          if (this.tabIndex === 2) {
            this.getLinkOrderData()
          } else {
            this.getData()
          }
        }
      }).catch((error) => {
        console.log(error)
      })
    },
    //取消修改价格
    clickPriceCancel(item) {
      item.freightFee = item.freightFee1
      item.showEditPrice = false
    },
    deliveryCompanyChange(e) {
      if (e.indexOf('顺丰') !== -1 && this.isOpenSF) {
        this.showParentOrder = true
      } else {
        this.showParentOrder = false
      }
    },
    clickTab(index) {
      this.ids = []
      this.checkedItemArray = []
      this.tabIndex = index
      this.clickSearch()
    },
    clickSearch() {
      if (this.tabIndex === 2) {
        this.tab2Obj.pageNo = 1
        this.getLinkOrderData()
      } else {
        this.pageNo = 1
        this.getData()
      }
    },
    clickClear() {
      if (this.tabIndex === 2) {
        this.tab2Obj.linkOrderNo = ''
        this.tab2Obj.hospital = ''
        this.tab2Obj.linkStatus = ''
        this.tab2Obj.printStatus = ''
        this.tab2Obj.selectDate = []
      } else {
        this.number = ''
        this.name = ''
        this.hospital = ''
        this.organization = ''
        this.selectDateType = 0
        this.selectDate = []
        this.selectCompany = ''
        this.selectPrintStatus = ''
      }
      this.clickSearch()
    },
    //选择
    selectionChange(e) {
      let ids = []
      for (let item of e) {
        ids.push(item.id)
      }
      this.ids = ids
      this.checkedItemArray = e
      this.getIsOpenSF()
    },
    //赋值每一行的下标
    tableRowClassName({row, rowIndex}) {
      row.index = rowIndex;
    },
    //某一行点击
    rowClick(row, column, event) {
      if (column.no !== 0 && column.no !== 1 && column.no !== 4 && column.no !== 23) {
        this.selectItem = row
        this.visibleDetail = true
      }
    },
    rowClickLink(row, column, event) {
      if (column.no !== 0 && column.no !== 1 && column.no !== 11) {
        this.selectItem = row
        this.visibleLinkDetail = true
      }
    },
    //上一个
    clickLeft() {
      let index = this.selectItem.index
      if (index > 0) {
        index--
      } else {
        this.$message.error('已经是当前页的第1条')
      }
      this.selectItem = this.tableData[index]
    },
    //下一个
    clickRight() {
      let index = this.selectItem.index
      if (index < this.tableData.length - 1) {
        index++
      } else {
        this.$message.error('已经是当前页的最后一条')
      }
      this.selectItem = this.tableData[index]
    },
    //发货
    clickSend() {
      if (this.ids.length === 0) {
        this.$message.error('请先选择订单')
        return
      }
      let arr = []
      for (let item of this.checkedItemArray) {
        if (this.tabIndex === 2) {//订单状态 0已作废，1已制单，2已签收，3已取消发货，4已发货
          if (item.orderStatus === 1) {//发货只能选择已制单状态的联单进行发货
            arr.push(item)
          }
        } else {
          arr.push(item)
        }
      }
      if (arr.length === 0) {
        this.$confirm("所选订单没有可以发货的订单", "温馨提示", {
          confirmButtonText: "知道了",
          showCancelButton: false,
          type: "warning",
        }).then(() => {
        }).catch(() => {
        });
      } else {
        this.sendItemArray = arr
        this.visibleSend = true
      }
    },
    //取消发货
    clickCancelSend() {
      if (this.ids.length === 0) {
        this.$message.error('请先选择订单')
        return
      }
      //取消发货按钮只能选择已发货未签收的处方
      let ids = [];//取消发货的id集合
      let linkOrderArray = [];//有联单的订单集合
      if (this.tabIndex === 2) {//联单
        ids = this.checkedItemArray.filter(item => {//订单状态 0已作废，1已制单，2已签收，3已取消发货，4已发货
          return item.orderStatus === 4
        }).map(item => {
          return item.id
        })
      } else {
        linkOrderArray = this.checkedItemArray.filter(item => {
          return item.faStatus === 1 && item.jointNo && item.jointNo !== ''
        })
        ids = this.checkedItemArray.filter(item => {//faStatus 0或者null待发货，1已发货，2已签收
          return item.faStatus === 1
        }).map(item => {
          return item.id
        })
      }
      if (ids.length === 0) {
        this.$confirm("只能操作已发货未签收状态的订单，当前没有可操作的订单", "温馨提示", {
          confirmButtonText: "知道了",
          showCancelButton: false,
          type: "warning",
        }).then(() => {
        }).catch(() => {
        });
      } else {
        //判断订单是否是联单的
        if (linkOrderArray.length !== 0) {
          let names = linkOrderArray.map(item => {
            return '【' + item.patientName + '】'
          }).join('')
          this.$confirm("患者" + names + "的处方单已联单发货，若取消发货联单内所有订单将被取消发货，您确定取消发货吗？", "温馨提示", {
            confirmButtonText: "确定",
            cancelButtonText: "再想想",
            type: "warning",
          }).then(() => {
            this.$postRequest('/admin/order/fahuoCancel', {
              ids: ids,
              type: this.tabIndex === 2 ? 2 : 1,//1普通订单，2联单
            }).then((res) => {
              if (res) {
                this.$message.success(res.message)
                this.clickSearch()
              }
            }).catch((error) => {
              console.log(error)
            })
          }).catch(() => {
          });
        } else {
          this.$confirm("您确定要取消发货吗？", "温馨提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          }).then(() => {
            this.$postRequest('/admin/order/fahuoCancel', {
              ids: ids,
              type: this.tabIndex === 2 ? 2 : 1,//1普通订单，2联单
            }).then((res) => {
              if (res) {
                this.$message.success(res.message)
                this.clickSearch()
              }
            }).catch((error) => {
              console.log(error)
            })
          }).catch(() => {
          });
        }
      }
    },
    //签收
    clickReceive() {
      if (this.ids.length === 0) {
        this.$message.error('请先选择订单')
        return
      }
      //只能选择已发货的状态订单进行操作
      let ids = []
      if (this.tabIndex === 2) {//联单
        ids = this.checkedItemArray.filter(item => {//订单状态 0已作废，1已制单，2已签收，3已取消发货，4已发货
          return item.orderStatus === 4
        }).map(item => {
          return item.id
        })
      } else {
        ids = this.checkedItemArray.filter(item => {//faStatus 0或者null待发货，1已发货，2已签收
          return item.faStatus === 1
        }).map(item => {
          return item.id
        })
      }
      if (ids.length === 0) {
        this.$confirm("只能操作已发货状态的订单，当前没有可签收的订单", "温馨提示", {
          confirmButtonText: "知道了",
          showCancelButton: false,
          type: "warning",
        }).then(() => {
        }).catch(() => {
        });
      } else {
        this.$confirm("您确定要签收吗？", "温馨提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(() => {
          this.$postRequest('/admin/order/signReceive', {
            ids: ids,
            type: this.tabIndex === 2 ? 2 : 1,//1普通订单，2联单
          }).then((res) => {
            if (res) {
              this.$message.success(res.message)
              this.clickSearch()
            }
          }).catch((error) => {
            console.log(error)
          })
        }).catch(() => {
        });
      }
    },
    //生成联单
    clickMergeOrder() {
      if (this.ids.length < 2) {
        this.$message.error('请至少选择2个订单')
        return
      }
      this.getIsOpenSF()
      this.getDelivery()
      let item = this.checkedItemArray[0]//回显收货地址
      this.linkOrderItem.receiveName = item.receiveName
      this.linkOrderItem.receiveMobile = item.receiveMobile
      this.linkOrderItem.receiveProvince = item.receiveProvince
      this.linkOrderItem.receiveCity = item.receiveCity
      this.linkOrderItem.receiveRegion = item.receiveRegion
      this.linkOrderItem.receiveAddress = item.receiveAddress
      this.linkOrderItem.orderIds = this.ids
      this.visibleLinkOrder = true
    },
    //母单改变，回显母单收货地址
    parentOrderIdChange(e) {
      let arr = this.checkedItemArray.filter(item => {
        return item.id === e
      })
      if (arr.length > 0) {
        let item = arr[0]
        this.linkOrderItem.receiveName = item.receiveName
        this.linkOrderItem.receiveMobile = item.receiveMobile
        this.linkOrderItem.receiveProvince = item.receiveProvince
        this.linkOrderItem.receiveCity = item.receiveCity
        this.linkOrderItem.receiveRegion = item.receiveRegion
        this.linkOrderItem.receiveAddress = item.receiveAddress
      }
    },
    //打印面单
    clickPrintFaceOrder() {
      if (!this.isOpenSF) {
        this.$confirm("暂不支持打印，如需打印，请在【系统管理-快递管理】里打开顺丰速运开通开关并填写月结号等信息", "温馨提示", {
          confirmButtonText: "知道了",
          showCancelButton: false,
          type: "warning",
        }).then(() => {
        }).catch(() => {
        });
        return;
      }
      if (this.ids.length === 0) {
        this.$message.error('请先选择订单')
        return
      }
      if (this.ids.length > 4) {
        this.$confirm("最多可同时打印4条处方订单", "温馨提示", {
          confirmButtonText: "知道了",
          showCancelButton: false,
          type: "warning",
        }).then(() => {
        }).catch(() => {
        });
        return;
      }
      let tempArray = [];//可打印订单
      for (let item of this.checkedItemArray) {//筛选出顺丰速运的
        if (item.deliveryCompany.indexOf('顺丰') !== -1) {
          tempArray.push(item)
        }
      }
      if (tempArray.length !== this.checkedItemArray.length) {
        let num = this.checkedItemArray.length - tempArray.length
        let orderNos = tempArray.map(item => {
          if (this.tabIndex === 2) {
            return '【' + item.jointNo + '】'
          } else {
            return '【' + item.orderNo + '】'
          }
        })
        this.$confirm("打印面单只能打印顺丰速运的订单，当前选择的订单中，忽略数量：" + num +
            "，可打印数量：" + tempArray.length + (orderNos.length > 0 ? '，包含：' + orderNos.join('') : '') + "", "温馨提示", {
          confirmButtonText: "知道了",
          showCancelButton: false,
          type: "warning",
        }).then(() => {
          if (tempArray.length > 0) {
            this.visibleFaceOrder = true
          }
        }).catch(() => {
        });
      } else {
        this.visibleFaceOrder = true
      }
    },
    //添加备注
    clickAddRemark() {
      if (this.ids.length === 0) {
        this.$message.error('请先选择订单')
        return
      }
      this.remark = ''
      this.visibleRemark = true
    },
    //保存备注
    clickSaveRemark() {
      if (this.$method.isEmpty(this.remark)) {
        this.$message.error('请输入备注')
        return
      }
      this.$postRequest('/admin/order/jieAddRemark', {
        ids: this.ids,
        remark: this.remark,
        type: 9,//1接方 2审方 3执行入库 4调剂添加备注, 5复核添加备注, 6泡药，7煎药，8包装，9发货
      }).then((res) => {
        if (res) {
          this.visibleRemark = false
          this.remark = ''
          this.$message.success('添加成功')
          this.getData()
        }
      }).catch((error) => {
        console.log(error)
      })
    },
    clickExport() {
      let token = sessionStorage.getItem('token')
      let param = {
        orderNo: this.number,
        patientName: this.name,
        hospitalName: this.hospital,
        mechName: this.organization,
        status: this.tabIndex === 0 ? 103 : this.tabIndex === 1 ? 104 : '',
        //订单状态 0 已作废 1 待接方列表 2 待审方
        // 90接方查询，91审方查询，92待入库列表，93带调剂列表，
        // 94调剂查询 ，95待复核列表 96复核查询, 97带泡药列表 98泡药查询 99带煎药列表 100煎药查询, 101 带包装列表，
        // 102包装查询，103待发货列表，104发货查询，105处方查询
        prescriptionStatus: this.tabIndex === 0 ? 9 : this.tabIndex === 1 ? 10 : '',
        //v27 处方状态，0待审方，1待复核，2代调剂，3带泡药，4正在泡药，5代煎药，6正在煎药，
        // 7带包装，8正在包装，9待发货，10已发货，11待接方，12接方作废，13审方作废，14调剂作废，15接方通过，16审方通过，
        // 17待入库，18已入库，19调剂完成，20复核驳回，21复核完成
        start: this.selectDate[0] ? this.selectDate[0] : '',
        end: this.selectDate[1] ? this.selectDate[1] : '',
        dateType: this.tabIndex === 0 ? '' : this.selectDateType,//v27 日期类型，0传方，1操作, 2泡药煎药时间
        pageNumber: this.pageNo,
        token: token,
      }
      let url = this.$baseUrl + '/admin/order/orderExport?' + this.$method.getParamsString(param)
      window.open(url)
    },
    //导出发货联单
    clickExportLink() {
      let token = sessionStorage.getItem('token')
      let param = {
        jointNo: this.tab2Obj.linkOrderNo,
        hospitalName: this.tab2Obj.hospital,
        orderStatus: this.tab2Obj.linkStatus,
        printStatus: this.tab2Obj.printStatus,
        start: this.tab2Obj.selectDate[0] ? this.tab2Obj.selectDate[0] : '',
        end: this.tab2Obj.selectDate[1] ? this.tab2Obj.selectDate[1] : '',
        pageNumber: this.tab2Obj.pageNo,
        token: token,
      }
      let url = this.$baseUrl + '/admin/order/joinOrderExport?' + this.$method.getParamsString(param)
      window.open(url)
    },
    //作废
    clickCancel() {
      if (this.ids.length === 0) {
        this.$message.error('请先选择订单')
        return
      }
      //不是作废状态的才可以作废
      let ids = []
      if (this.tabIndex === 2) {//只有联单有作废按钮
        ids = this.checkedItemArray.filter(item => {//订单状态 0已作废，1已制单，2已签收，3已取消发货，4已发货
          return item.orderStatus !== 0
        }).map(item => {
          return item.id
        })
      }
      if (ids.length === 0) {
        this.$confirm("当前选择的订单没有可以作废的订单", "温馨提示", {
          confirmButtonText: "知道了",
          showCancelButton: false,
          type: "warning",
        }).then(() => {
        }).catch(() => {
        });
      } else {
        this.$confirm("您确定要作废吗？", "温馨提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(() => {
          this.$postRequest('/admin/order/joinOrderCancel', {
            ids: this.ids
          }).then((res) => {
            if (res) {
              this.$message.success(res.message)
              this.clickSearch()
            }
          }).catch((error) => {
            console.log(error)
          })
        }).catch(() => {
        });
      }
    },
    //删除
    clickDelete() {
      if (this.ids.length === 0) {
        this.$message.error('请先选择订单')
        return
      }
      //删除按钮只能选择已作废和已取消发货的联单进行删除
      let ids = this.checkedItemArray.filter(item => {//订单状态 0已作废，1已制单，2已签收，3已取消发货，4已发货
        return item.orderStatus === 0 || item.orderStatus === 3
      }).map(item => {
        return item.id
      })
      if (ids.length === 0) {
        this.$confirm("只能删除已作废和已取消发货的联单，当前选择的没有可操作的联单", "温馨提示", {
          confirmButtonText: "知道了",
          showCancelButton: false,
          type: "warning",
        }).then(() => {
        }).catch(() => {
        });
      } else {
        this.$confirm("您确定要删除吗？", "温馨提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(() => {
          this.$postRequest('/admin/order/joinOrderDelete', {
            ids: ids
          }).then((res) => {
            if (res) {
              this.$message.success(res.message)
              this.clickSearch()
            }
          }).catch((error) => {
            console.log(error)
          })
        }).catch(() => {
        });
      }
    },
    //物流信息
    clickExpressInfo() {
      if (this.ids.length === 0) {
        this.$message.error('请先选择订单')
        return
      }
      this.$postRequest('/admin/order/logisticsInfo', {
        ids: this.ids
      }).then((res) => {
        if (res) {
          this.logsInfoArray = res.data
          if (this.logsInfoArray.length === 0) {
            this.$confirm("暂无物流信息", "温馨提示", {
              confirmButtonText: "知道了",
              showCancelButton: false,
              type: "warning",
            }).then(() => {
              this.visibleExpressInfo = false
            }).catch(() => {
            });
          } else {
            this.visibleExpressInfo = true
          }
        }
      }).catch((error) => {
        console.log(error)
      })
    },
    //页数改变
    handleCurrentChange(pageNo) {
      this.pageNo = pageNo
      this.getData()
    },
    //页数改变
    handleCurrentChange2(pageNo) {
      this.tab2Obj.pageNo = pageNo
      this.getLinkOrderData()
    },
    //获取数据
    getData() {
      this.$getRequest('/admin/order/page', {
        orderNo: this.number,
        patientName: this.name,
        hospitalName: this.hospital,
        mechName: this.organization,
        status: this.tabIndex === 0 ? 103 : this.tabIndex === 1 ? 104 : '',
        //订单状态 0 已作废 1 待接方列表 2 待审方
        // 90接方查询，91审方查询，92待入库列表，93带调剂列表，
        // 94调剂查询 ，95待复核列表 96复核查询, 97带泡药列表 98泡药查询 99带煎药列表 100煎药查询, 101 带包装列表，
        // 102包装查询，103待发货列表，104发货查询，105处方查询
        prescriptionStatus: this.tabIndex === 0 ? 9 : this.tabIndex === 1 ? 10 : '',
        //v27 处方状态，0待审方，1待复核，2代调剂，3带泡药，4正在泡药，5代煎药，6正在煎药，
        // 7带包装，8正在包装，9待发货，10已发货，11待接方，12接方作废，13审方作废，14调剂作废，15接方通过，16审方通过，
        // 17待入库，18已入库，19调剂完成，20复核驳回，21复核完成
        start: this.selectDate[0] ? this.selectDate[0] : '',
        end: this.selectDate[1] ? this.selectDate[1] : '',
        dateType: this.tabIndex === 0 ? '' : this.selectDateType,//v27 日期类型，0传方，1操作, 2泡药煎药时间
        deliveryCompany: this.selectCompany,
        printStatus: this.selectPrintStatus,
        pageNumber: this.pageNo,
      }).then((res) => {
        if (res) {
          this.total = res.data.totalRow
          this.tableData = res.data.list
        }
      }).catch((error) => {
        console.log(error)
      })
    },
    //获取医院下拉
    getHospitalArray() {
      this.$getRequest('/admin/hospital/list', {}).then((res) => {
        if (res) {
          this.hospitalArray = res.data
        }
      }).catch((error) => {
        console.log(error)
      })
    },
    //生成联单保存
    clickSaveLinkOrder() {
      if (this.isSaving) return;
      if (this.$method.isEmpty(this.linkOrderItem.deliveryCompany)) {
        this.$message.error("请选择配送方式")
        return
      }
      if (this.linkOrderItem.deliveryCompany.indexOf('顺丰') !== -1
          && this.$method.isEmpty(this.linkOrderItem.orderId) && this.isOpenSF) {
        this.$message.error("请选择母单")
        return
      }
      if (this.$method.isEmpty(this.linkOrderItem.receiveName) || this.$method.isEmpty(this.linkOrderItem.receiveMobile)) {
        this.$message.error("请输入收件人信息")
        return
      }
      if (this.$method.isEmpty(this.linkOrderItem.receiveProvince) || this.$method.isEmpty(this.linkOrderItem.receiveCity)
          || this.$method.isEmpty(this.linkOrderItem.receiveRegion)) {
        this.$message.error("请输入收件人地址")
        return
      }
      if (this.$method.isEmpty(this.linkOrderItem.receiveAddress)) {
        this.$message.error("请输入收件人详细地址")
        return
      }
      this.isSaving = true
      this.$postRequest('/admin/sfExpress/createJointShipment', this.linkOrderItem).then((res) => {
        if (res) {
          this.$message.success(res.message)
          this.visibleLinkOrder = false
          this.clickSearch()
        }
        this.isSaving = false
      }).catch((error) => {
        console.log(error)
        this.isSaving = false
      })
    },
    provinceChange(e) {
      this.linkOrderItem.receiveCity = ''
      this.linkOrderItem.receiveRegion = ''
      this.cityArray = []
      this.areaArray = []
      if (e && e !== '') {
        for (let i = 0; i < this.provinceArray.length; i++) {
          let item = this.provinceArray[i]
          if (e === item.n) {
            this.cityArray = item.c
          }
        }
      }
    },
    cityChange(e) {
      this.linkOrderItem.receiveRegion = ''
      this.areaArray = []
      if (e && e !== '') {
        for (let i = 0; i < this.cityArray.length; i++) {
          let item = this.cityArray[i]
          if (e === item.n) {
            this.areaArray = item.c
          }
        }
      }
    },
    //获取联单列表
    getLinkOrderData() {
      this.$getRequest('/admin/order/sendOrderPage', {
        jointNo: this.tab2Obj.linkOrderNo,
        hospitalName: this.tab2Obj.hospital,
        orderStatus: this.tab2Obj.linkStatus,
        printStatus: this.tab2Obj.printStatus,
        start: this.tab2Obj.selectDate[0] ? this.tab2Obj.selectDate[0] : '',
        end: this.tab2Obj.selectDate[1] ? this.tab2Obj.selectDate[1] : '',
        pageNumber: this.tab2Obj.pageNo,
      }).then((res) => {
        if (res) {
          this.tab2Obj.total = res.data.totalRow
          this.tab2Obj.tableData = res.data.list
        }
      }).catch((error) => {
        console.log(error)
      })
    },
    //获取快递公司下拉
    getDelivery() {
      this.$getRequest('/admin/dict/getDelivery', {}).then((res) => {
        if (res) {
          this.companyArray = res.data
        }
      }).catch((error) => {
        console.log(error)
      })
    },
    //发货成功
    sendSuccess() {
      this.visibleSend = false
      this.clickSearch()
    },
    //获取是否开通顺丰
    getIsOpenSF() {
      this.$getRequest('/admin/sfExpress/getIsExpress ', {}).then((res) => {
        if (res) {
          this.isOpenSF = res.data
        }
      }).catch((error) => {
        console.log(error)
      })
    },
  },
  // 计算属性
  computed: {},
  // 侦听器
  watch: {},
}
</script>

<style lang="scss" scoped>
.sendManage {
  height: 100%;

  .tab-div {
    background: #FFFFFF;
    margin: 20px 20px 0 20px;
    padding: 20px 0 0 0;

    .tab-item {
      padding: 0 20px;
      cursor: pointer;

      .tab-title {
        font-size: 18px;
        padding-bottom: 20px;

        &-active {
          color: #215AA0;
          font-weight: bold;
        }
      }

      .tab-line {
        width: 100%;
        height: 2px;
        background: #FFFFFF;
        border-radius: 1px;

        &-active {
          background: #215AA0;
        }
      }
    }
  }

  .card-div {
    margin: 20px;
    background: #FFFFFF;
    box-shadow: 0 0 5px #F3F3F3;
    border-radius: 3px;
    padding: 20px;
    overflow: auto;

    .img-sign {
      width: 90px;
      height: 30px;
    }

    .img-table {
      height: 20px;
      object-fit: scale-down;
      margin-left: 10px;
    }
  }

  .left-div {
    width: 110px;
    text-align: right;
  }

  :deep(.el-timeline-item__timestamp) {
    font-size: 16px;
    color: #333333;
  }

  .logistics-title {
    color: #989898;
  }

  .grey-div {
    padding: 10px 15px;
  }
}

.dialog-title {
  font-size: 18px;
  color: #FFFFFF;
  margin-left: 20px;
}

.btn-next {
  width: 95px;
  height: 34px;
  line-height: 34px;
  text-align: center;
  border: 1px solid #FFFFFF;
  border-radius: 17px;
  font-size: 16px;
  color: #FFFFFF;
  cursor: pointer;
  margin-left: 20px;
}
</style>
